import React from 'react';
import PropTypes from 'prop-types';

import Footer from '../molecules/Footer';
import Header from '../molecules/Header';
// import Navigation from '../molecules/Navigation';

import '../../App.css';

const BasicBucket = ({ children }) => (
  <div id="page">
    <div id="header">
      <Header />
    </div>
    <div id="content">{children}</div>
    <div id="footer">
      <Footer />
    </div>
    {/* <Navigation /> */}
  </div>
);

export default BasicBucket;

BasicBucket.propTypes = {
  children: PropTypes.shape({}),
};

BasicBucket.defaultProps = {
  children: {},
};
